var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import PeopleWaitingRoomComponent from "../../components/animator_components/PeopleWaitingRoomComponent";
import WebcamComponent from "../../components/animator_components/WebcamComponent";
import InformationWaitingRoomComponent from "../../components/animator_components/InformationWaitingRoomComponent";
import InformationPreGameComponent from "../../components/animator_components/InformationPreGameComponent";
import { useNavigateKeepSession } from "../../tools/useNavigateKeepSession";
import useSessionContext from "../../tools/useSessionContext";
import { getDefaultGameStateDTO } from "cresus-common";
import { useBoardGame } from "../../contexts/BoardGameProvider";
import useMedia from "../../contexts/useMedia";
import ChatAnimatorComponent from "../../components/animator_components/ChatAnimatorComponent";
import AuthContext from "../../contexts/AuthContext";
function WaitingRoomPage() {
    var _a;
    const { playSound } = useBoardGame();
    const navigate = useNavigateKeepSession();
    const { sendRequest, websocketPeer } = useSessionContext();
    const { audioVideoClient } = useMedia();
    const [insideGameState, setInsideGameState] = useState(getDefaultGameStateDTO());
    // const [micOn, setMicOn] = useState(true);
    // const [cameraOn, setCameraOn] = useState(true);
    // --- FIX 1: Initialize state based on actual hardware status ---
    // If we just came from WaitingRoom, the producer might already exist.
    // Don't default to 'true', check the client.
    const [micOn, setMicOn] = useState(() => { var _a; return !((_a = audioVideoClient._producer) === null || _a === void 0 ? void 0 : _a.paused); });
    const [cameraOn, setCameraOn] = useState(() => !!audioVideoClient._webcamProducer);
    const [chatOn, setChatOn] = useState(false);
    const [paramOn, setParamOn] = useState(false);
    const [myPlayer, setMyPlayer] = useState();
    const [newMessageAlert, setNewMessageAlert] = useState(false);
    const auth = useContext(AuthContext);
    // Default to false if auth context is somehow missing
    const isCoanimator = (_a = auth === null || auth === void 0 ? void 0 : auth.isCoanimator) !== null && _a !== void 0 ? _a : false;
    const counter = 10; //10;
    function getMyPlayer() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield sendRequest("getMyPlayer", {
                gameState: insideGameState,
            }).catch((error) => {
                console.error("getMyPlayer", error);
            });
            if (result !== undefined)
                setMyPlayer(result);
        });
    }
    function startTheSession() {
        return __awaiter(this, void 0, void 0, function* () {
            yield sendRequest("startSession", {}).catch((error) => {
                console.error("startSession", error);
            });
        });
    }
    function handleClick() {
        playSound("GlobalAmbiance");
        startTheSession();
    }
    // functions to handle Notifications from the websocket //////////////////////////////
    function updateIfSessionStarted(message) {
        // console.log("test callback", message);
        const buffGameState = Object.assign({}, insideGameState);
        buffGameState.sessionStarted = message.data.gameState;
        setInsideGameState(buffGameState);
        navigate("/IntroductionRoomPage");
    }
    function updateLobbyPlayers(message) {
        console.log("newPlayer Added to session", message);
        const buffGameState = Object.assign({}, insideGameState);
        buffGameState.lobbyPlayers = message.data;
        console.log("Waitingroompage.updateLobbyPlayers() insideGameState", insideGameState);
        console.log("newPlayer Added to session", buffGameState);
        setInsideGameState((gameState) => {
            return Object.assign(Object.assign({}, gameState), { lobbyPlayers: message.data });
        });
    }
    function getGameState() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield sendRequest("onConnectionOrReaload", {}).catch((error) => {
                console.error("onConnectionOrReaload", error);
            });
            console.log("WaitingRoomPage.getGameState()", result);
            if (result !== undefined) {
                setInsideGameState(result);
            }
        });
    }
    // 1. Hook for WebSocket Listeners (Must be separate to avoid multiple subscriptions)
    useEffect(() => {
        if (!websocketPeer || websocketPeer.data.hasListeners)
            return;
        const handleNotification = (notification) => {
            // Logic to update state
            if (notification.method === "updateGameState")
                setInsideGameState(notification.data);
            if (notification.method === "startSession")
                updateIfSessionStarted(notification);
            if (notification.method === "newPlayerToLobby")
                updateLobbyPlayers(notification);
        };
        websocketPeer.on("notification", handleNotification);
        // Mark that listeners are attached so they aren't added again on re-render
        websocketPeer.data.hasListeners = true;
        // No cleanup possible with this class definition,
        // but the 'hasListeners' flag prevents duplicates.
    }, [websocketPeer]);
    // ------------------------------------------------------------------
    // FIXED INITIALIZATION LOGIC
    // ------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const initializePage = () => __awaiter(this, void 0, void 0, function* () {
            try {
                if (!isMounted)
                    return;
                // Step C: Fetch Game Data
                yield Promise.all([getGameState(), getMyPlayer()]);
                // Step D: Start Ambience
                playSound("GlobalAmbiance");
                console.log("Initialization complete");
            }
            catch (error) {
                console.error("Initialization failed:", error);
                // Only redirect on error if it's strictly an auth failure for main animators
                if (!isCoanimator) {
                    navigate("/");
                }
            }
        });
        initializePage();
        return () => {
            isMounted = false;
        };
    }, [isCoanimator]); // Added dependency
    return (_jsxs("div", Object.assign({ className: "absolute w-screen flex h-screen bg-dilemmeSimplePurple" }, { children: [myPlayer && (_jsx(ChatAnimatorComponent, { newMessageAlert: setNewMessageAlert, isChatShown: chatOn, toggleChat: () => setChatOn((prev) => !prev), myPlayer: myPlayer })), _jsxs("div", Object.assign({ className: "flex h-full flex-col", style: {
                    backgroundColor: "rgba(0, 0, 0, 0.50)",
                    width: "25%",
                    minWidth: "256px",
                    zIndex: 2,
                } }, { children: [_jsxs("div", Object.assign({ className: "flex text-white font-roboto w-full", style: {
                            paddingLeft: "20px",
                            paddingTop: "33px",
                            height: "91px",
                            minHeight: "91px",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: "400",
                            lineHeight: "normal",
                        } }, { children: [insideGameState.lobbyPlayers.length, " joueurs dans ", _jsx("br", {}), " la salle d'attente"] })), _jsx("div", Object.assign({ className: "flex relative", style: {
                            paddingTop: "20px",
                            paddingRight: "10px",
                            height: "100%",
                            minHeight: "305px",
                            borderTop: "1px solid rgba(255, 255, 255, 0.20)",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.20)",
                        } }, { children: _jsx("div", Object.assign({ className: "flex relative overflow-y-auto w-full flex-col", style: {
                                paddingLeft: "20px",
                                paddingRight: "8px",
                                height: "100%",
                                gap: "5px",
                            } }, { children: insideGameState.lobbyPlayers.map((person, index) => {
                                return (_jsx(PeopleWaitingRoomComponent, { player: person, sessionPeerId: person.sessionPeerId, mediaAPIPeerId: person.mediaAPIPeerId, name: person.name }, `peopleInWait${index}`));
                            }) })) })), _jsx(WebcamComponent, { isCommunicationActive: true, isThereNotification: newMessageAlert, newMessageAlert: setNewMessageAlert, isChatActive: true, cameraOn: cameraOn, setCameraOn: setCameraOn, micOn: micOn, setMicOn: setMicOn, chatOn: chatOn, setChatOn: setChatOn, paramOn: paramOn, setParamOn: setParamOn })] })), _jsxs("div", Object.assign({ className: "flex flex-col justify-start h-full w-full", style: {
                    paddingLeft: "50px",
                    paddingRight: "50px",
                } }, { children: [_jsx(InformationPreGameComponent, { buttonActive: true, textButton: "Lancer la session", onClickButton: () => {
                            handleClick();
                        }, sessionName: insideGameState.animatorSessionName, counterEnded: false, counter: counter }), _jsxs("div", Object.assign({ className: "flex flex-row w-full h-full" }, { children: [_jsxs("div", Object.assign({ className: " flex flex-col justify-start w-full h-full" }, { children: [_jsx("div", Object.assign({ className: "flex text-white font-roboto w-full", style: {
                                            paddingTop: "20px",
                                            paddingBottom: "20px",
                                            fontSize: "24px",
                                            fontWeight: "700",
                                            lineHeight: "28px",
                                            zIndex: 10,
                                        } }, { children: "Informations de la session" })), _jsxs("div", Object.assign({ className: "flex flex-col gap-4" }, { children: [_jsx(InformationWaitingRoomComponent, { tag: "Deck", information: insideGameState.deckName }), _jsx(InformationWaitingRoomComponent, { tag: "Langue", information: insideGameState.language }), _jsx(InformationWaitingRoomComponent, { tag: "Commentaire", information: insideGameState.comment.length > 0
                                                    ? insideGameState.comment
                                                    : "Pas de commentaire" })] }))] })), _jsx("div", { className: "flex relative", style: {
                                    right: "-50px",
                                    minWidth: "359px",
                                    minHeight: "359px",
                                    backgroundImage: "url(/assets/UI/cygogne_prepartie.png)",
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPositionX: "right",
                                    backgroundPositionY: "bottom",
                                } })] }))] }))] })));
}
export default WaitingRoomPage;
